import {
    SUPER_ADMIN_MENU_ITEMS,
    CUSTOMER_ADMIN_MENU_ITEMS,
    MenuItemType,
    EMPLOYEE_MENU_ITEMS,
    ANALYST_CUSTOMER_MENU_ITEMS,
} from 'appConstants';

const getMenuItems = (role: string, isSuperAdmin: boolean) => {
    if (role === 'ADMIN' && isSuperAdmin === true) {
        return SUPER_ADMIN_MENU_ITEMS;
    } else {
        switch (role) {
            case 'CUSTOMER_ADMIN':
                return CUSTOMER_ADMIN_MENU_ITEMS;
            case 'EMPLOYEE':
                return EMPLOYEE_MENU_ITEMS;
            case 'ANALYST':
                return ANALYST_CUSTOMER_MENU_ITEMS;

            default:
                return;
        }
    }
};

const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemType[] | undefined,
    menuItemKey: MenuItemType['key'] | undefined
): MenuItemType | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { getMenuItems, findAllParent, findMenuItem };
